export const RECAPTCHA_ACTION = "sms_download_link";
